import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: { xs: 12, md: 16 },
        left: { xs: 12, md: 16 },
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        cursor: "pointer",
        color: isDark ? "#9ca3af" : "#64748b",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        transition: "all 200ms linear",
        "&:hover": {
          color: isDark ? "#e4e6ea" : "#0f172a",
          backgroundColor: isDark
            ? "rgba(255,255,255,0.08)"
            : "rgba(0,0,0,0.04)",
        },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
      <Typography
        sx={{
          fontSize: { xs: "0.8125rem", sm: "0.875rem" },
          fontWeight: 500,
        }}
      >
        Back
      </Typography>
    </Box>
  );
};

export default BackButton;
